import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

/**
 * Persistent banner shown to customers while the store is in test mode.
 * Orders placed in test mode are excluded from analytics/revenue/invoices and
 * never trigger a charge, so we surface a clear, always-visible notice.
 */
const TestModeBanner = ({ testModeEnabled }) => {
  if (!testModeEnabled) {
    return null;
  }

  return (
    <div
      className="test-mode-banner"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2000,
        backgroundColor: '#f97316',
        color: '#431407',
        padding: '0.4rem 1rem',
        textAlign: 'center',
        fontWeight: 600,
        fontSize: '0.9rem',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
      }}
    >
      <FormattedMessage id="test_mode_banner" />
    </div>
  );
};

TestModeBanner.propTypes = {
  testModeEnabled: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  testModeEnabled: !!state.store.store?.testModeEnabled,
});

export default connect(mapStateToProps)(TestModeBanner);
